import type { ContentNugget } from '@backrs_ui/common-ui';

import { toAgentContextNugget } from '@backrs_ui/grow-ui/src/agentContext/toAgentContextNugget';
import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { Category, SearchCategory } from '@backrs_ui/grow-ui/src/pages/Search/search.types';

export const useAgentContext = ({
  totalBookmarks,
  searchTerm,
  selectedCategories,
  availableCategories,
  currentPage,
  totalPages,
  visibleNuggets,
}: {
  totalBookmarks: number;
  searchTerm: string;
  selectedCategories: SearchCategory[];
  availableCategories: Category[];
  currentPage: number;
  totalPages: number;
  visibleNuggets: readonly ContentNugget[];
}) => {
  useRegisterAgentContext({
    kind: 'nuggetList',
    description: 'Bookmarked items the user has saved',
    nuggets: visibleNuggets.map(toAgentContextNugget),
    data: {
      totalBookmarks,
      searchTerm: searchTerm || null,
      activeCategoryFilters: selectedCategories.length > 0 ? selectedCategories.join(', ') : null,
      availableCategoryFilters:
        availableCategories.length > 0 ? availableCategories.map((c) => c.label).join(', ') : null,
      currentPage,
      totalPages,
    },
  });
};
